import { motion } from 'framer-motion'
import Link from './Link'
import { featuredProducts } from '../data/products'
import ProductCarousel from './ProductCarousel'

const Hero = () => {
  return (
    <section id="home" className="relative overflow-hidden bg-[#f7f8f5] pt-28">
      <div className="container mx-auto px-4">
        <div className="grid min-h-[calc(100vh-7rem)] items-center gap-12 pb-16 pt-8 lg:grid-cols-[1fr_0.92fr]">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <p className="mb-5 text-sm font-semibold uppercase tracking-[0.28em] text-teal-700">
              Prosthetics and Orthotics Export Partner
            </p>
            <h1 className="text-5xl font-semibold leading-[1.02] text-slate-950 md:text-7xl">
              Precision components for confident mobility.
            </h1>
            <p className="mt-7 max-w-2xl text-lg leading-8 text-slate-600">
              Angel Technology International Co., Ltd. focuses on rehabilitation products,
              prosthetic components and orthopedic products for global trade, supplying a broad
              catalog backed by quality control, customer service and efficient logistics.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/#portfolio"
                className="rounded-md bg-slate-950 px-7 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-teal-700"
              >
                Explore Products
              </Link>
              <Link
                to="/#about"
                className="rounded-md border border-slate-300 px-7 py-3 text-center text-sm font-semibold text-slate-800 transition-colors hover:border-teal-700 hover:text-teal-700"
              >
                Company Advantages
              </Link>
            </div>
            <dl className="mt-12 grid max-w-xl grid-cols-3 gap-5 border-t border-slate-300 pt-7">
              {[
                ['12', 'Featured products'],
                ['3', 'Core categories'],
                ['Global', 'Export markets']
              ].map(([value, label]) => (
                <div key={label}>
                  <dt className="text-2xl font-semibold text-slate-950">{value}</dt>
                  <dd className="mt-1 text-xs uppercase tracking-[0.16em] text-slate-500">{label}</dd>
                </div>
              ))}
            </dl>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="relative"
          >
            <ProductCarousel products={featuredProducts.slice(0, 3)} />
          </motion.div>
        </div>
      </div>
    </section>
  )
}

export default Hero
